import React from "react";
import { Typography } from "@material-ui/core";
import { TextField } from "react-admin";
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

const useComentarioStyles = makeStyles({
  clamp: {
    display: "-webkit-box",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
  },
});

const LogActivityCambioSubestado = ({ record: registro }) => {
  const classes = useComentarioStyles();
  return registro ? (
    <>
      <Typography
        variant="body2"
        gutterBottom
        // component={RouterLink}
        // to={`/comentarios/${registro.id}`}
        style={{ textDecoration: "none" }}
      >
        {`Cambio de subestado realizado por el usuario `}
        &nbsp;[
        {registro.user ? (
          <TextField source="user.name" label="" record={registro} />
        ) : (
          `desconocido`
        )}
        ]
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        gutterBottom
      ></Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.clamp}
      >
        {registro.texto}
      </Typography>
    </>
  ) : null;
};
export default LogActivityCambioSubestado;
